export default {
  topPage: (): string => '/',
  visionPage: (): string => '/vision/',
  visionAiWorkspacePage: (): string => '/vision/ai-workspace/',
  visionEngineeringPage: (): string => '/vision/engineering/',
  visionSpecificAiPage: (): string => '/vision/specific-ai/',
  visionProductPage: (): string => '/vision/product/',
  visionStartupPage: (): string => '/vision/startup/',
  visionB2bServicePage: (): string => '/vision/b2b-service/',
  visionDarsPage: (): string => '/vision/dars/',
  visionCommunityPage: (): string => '/vision/community/',
  articlePage: (tag?: string, type?: string): string => {
    const params = new URLSearchParams()
    if (tag) {
      params.set('tag', tag.trim())
    }
    if (type) {
      params.set('type', type.trim())
    }
    const qs = params.toString()
    return qs ? `/article/?${qs}` : '/article/'
  },
  aboutPage: (query?: string): string => (query ? `/about/${query}` : '/about/'),
  kagglePage: (): string => '/kaggle/',
  recruitPage: (): string => '/recruit/',
  contactPage: (): string => '/contact/',
  errorPage: () => '/404/',
  // News
  newsPage: (): string => '/news/',
  newsDetailPage: (slug: string): string => `/news/${slug}/`,
  // Works
  worksPage: (): string => '/works/',
  workDetailPage: (slug: string): string => `/works/${slug}/`,
  // Story
  storyPage: (): string => '/story/',
  storyDetailPage: (slug: string): string => `/story/${slug}/`,
  // tech posts
  techPostPage: () => '/techposts/',
  communityPage: () => '/community/',
  // summer internship
  summerInternshipPage: () => '/recruit/internship/',
  // event
  eventPage: () => '/event/',
  specialistPage: () => '/specialist/'
}
